import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Colors } from '@lichtblick/theme';
import { Text } from '@lichtblick/ui-components';
import { StepContent, Step as StyledStep, Steps as StyledSteps } from './Steps.styles';
export const Step = ({ backgroundColor = Colors.White, icon: Icon, text })=>/*#__PURE__*/ _jsx(StyledStep, {
        children: /*#__PURE__*/ _jsxs(StepContent, {
            $backgroundColor: backgroundColor,
            children: [
                /*#__PURE__*/ _jsx(Icon, {}),
                /*#__PURE__*/ _jsx(Text, {
                    isBold: true,
                    size: "S",
                    children: text
                })
            ]
        })
    });
export const Steps = ({ children })=>/*#__PURE__*/ _jsx(StyledSteps, {
        children: children
    });

//# sourceMappingURL=Steps.js.map